import Home from "./Home";
import OneWrapper from "./one";

export const ValidatorCollectsHome = Home;
export const ValidatorCollectsOneWrapper = OneWrapper;
